import { render, staticRenderFns } from "./AssetCategory.vue?vue&type=template&id=37b1933a&scoped=true&"
import script from "./AssetCategory.vue?vue&type=script&lang=ts&"
export * from "./AssetCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1933a",
  null
  
)

export default component.exports